import { useMutation } from '@tanstack/react-query';

import { objectToFormData } from 'src/utils/helper';
import { USER_ID_STORAGE_KEY } from 'src/utils/constants';

import { restClient, userClient } from 'src/lib/api';

export const useCompanyRegister = () => {
  const mutationFn = (payload) =>
    restClient
      .post(
        'companyRegistration',
        objectToFormData({ ...payload, userID: sessionStorage.getItem(USER_ID_STORAGE_KEY) })
      )
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
  });
};

export const useUserRegister = () => {
  const mutationFn = (payload) =>
    userClient
      .post('api/v1/user/userRegistration', {
        ...payload,
        userID: sessionStorage.getItem(USER_ID_STORAGE_KEY),
      })
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
  });
};
